import cn from 'classnames';
import { GoogleLogin } from '@react-oauth/google';

//Types
import { IGoogleAuthBtn } from '~components/GoogleAuthBtn/types';
import { AuthLoadingState } from '~context/auth/types';
//Constants
import { GOOGLE_CLIENT_ID, URL_ORIGIN } from '~config/constants';
//GraphQL
import { useGoogleLoginMutation } from '~graphqlResources';
//Context
import { useAuthContext } from '~context/auth';
//Hooks
import {useCommonModals} from '~context/commonModals';
import useDimensions from '~hooks/useDimensions';



export default function GoogleAuthBtn({
    title,
    className,
    onAuthSuccess,
    onAuthFail,
    actionType
}: IGoogleAuthBtn) {
    const { login, setAuthLoadingState } = useAuthContext();
    const { openErrorModal } = useCommonModals();
    const { vw } = useDimensions();

    const [googleLogin] = useGoogleLoginMutation({
        update(
            _,
            {
                data: {
                    loginBySocialToken: { profile, jwt }
                }
            }
        ) {
            if (jwt && profile) {
                login({ profile, jwt });
                onAuthSuccess({ profile, jwt });
            }
        },
        onError(err) {
            onAuthFail(err);
            setAuthLoadingState(AuthLoadingState.FAILED);
        }
    });

    const responseSuccessGoogle = (response: any) => {
        if (response?.credential) {
            setAuthLoadingState(AuthLoadingState.PENDING);

            googleLogin({
                variables: {
                    token: response.credential,
                    callback: `${URL_ORIGIN}/google`
                }
            });
        } else {
            setAuthLoadingState(AuthLoadingState.FAILED);
            openErrorModal({
                modalBody: 'Token Id is missing in google response',
                reportData: {
                    error: new Error('Token Id is missing in google response'),
                    errorScope: 'Google Authentication',
                    extraData: response
                }
            });
        }
    };

    const responseErrorGoogle = () => {
        setAuthLoadingState(AuthLoadingState.FAILED);
        // eslint-disable-next-line no-console
        console.log('Google auth fail');
    };

    if (!GOOGLE_CLIENT_ID) return null;

    return (
        <div className={cn(className)}>
            <GoogleLogin
                size="medium"
                text={actionType === 'SIGN_IN' ? 'signin_with' : 'signup_with'}
                type="standard"
                shape="rectangular"
                // @ts-ignore
                width={vw < 392 ? vw - 40 : 352}
                onSuccess={responseSuccessGoogle}
                onError={responseErrorGoogle}
            />
        </div>
    );
}
